import angular from 'angular';

import dynamicTextDirective from './dynamic-text.directive';

export default angular.module('dbm.dashboard.shared.dynamic-text', [])
.directive('dbmDynamicText', () => new dynamicTextDirective())
.name;


// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/shared/dynamic-text/index.js